import { render, staticRenderFns } from "./pageone.vue?vue&type=template&id=e10a23ec&scoped=true"
import script from "./pageone.vue?vue&type=script&lang=js"
export * from "./pageone.vue?vue&type=script&lang=js"
import style0 from "./pageone.vue?vue&type=style&index=0&id=e10a23ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10a23ec",
  null
  
)

export default component.exports